/**
 * Coarse pointers / narrow viewports get the compact mobile editor chrome
 * (collapsed side panels, one-finger 3D pan, scrollable toolbars).
 */
export const MOBILE_UI_MEDIA_QUERY = "(pointer: coarse), (max-width: 767px)";

export function isMobileUi(): boolean {
  if (
    typeof window === "undefined" ||
    typeof window.matchMedia !== "function"
  ) {
    return false;
  }
  return window.matchMedia(MOBILE_UI_MEDIA_QUERY).matches;
}
